import React from 'react'

import EmptyResults from '@cinch/oxd-components/empty-results/src'
import GuideSummary from '@cinch/oxd-components/guide-summary/src'
import Link from '@cinch/oxd-components/link/src'
import Title from '@cinch/oxd-components/page-title/src'
import Pagination from '@cinch/oxd-components/pagination/src'
import SearchForm from '@cinch/oxd-components/search-form/src'
import useSearch from '@cinch/oxd-hooks/search-guides/src'
import Layout from '@cinch/oxd-layouts/regular/src'

import { GuideSummaryProps } from '@cinch/oxd-components/guide-summary/src/guide-summary.component'
import { PaginationProps } from '@cinch/oxd-components/pagination/src/pagination.component'

import * as styles from './guides.module.css'

export interface GuidesProps {
  i18n: Cinch.WebAppTranslations['guides']
  items: GuideSummaryProps[]
  pagination: PaginationProps
}

const Guides: React.FC<GuidesProps> = ({ i18n, items, pagination }) => {
  const { status, makeRequest, searchItems, term } = useSearch()
  const handleSearch = ({ search }: any) => makeRequest(search)

  return (
    <Layout>
      <Title>{i18n.title}</Title>
      <SearchForm
        searchPending={status === 'pending'}
        onSubmit={handleSearch}
        i18n={{ placeholder: i18n.searchPlaceholder, search: 'Search' }}
      />
      {status === 'success' && (
        <>
          <Title element="h2">
            Results for <span>{term}</span>
          </Title>
          {searchItems.length === 0 ? (
            <EmptyResults
              body={i18n.noResultsBody}
              searchTerms={['Testing tyre pressure', 'Changing windscreen wipers', 'what are spark plugs?']}
            />
          ) : (
            <ul>
              {searchItems.map((item) => (
                <li key={item.id}>
                  <Link to={`/post/${item.id}`} className={styles.link} aria-label={item.headline}>
                    <GuideSummary {...item} />
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </>
      )}
      {status === 'initial' && (
        <>
          <ul>
            {items.map((item) => (
              <li key={item.id}>
                <Link to={`/post/${item.id}`} className={styles.link} aria-label={item.headline}>
                  <GuideSummary {...item} />
                </Link>
              </li>
            ))}
          </ul>
          <div className={styles.pagination} data-testid="guides__pagination-wrapper">
            <Pagination {...pagination} hideDisabled={true} hideFirstLastPages={true} />
          </div>
        </>
      )}
    </Layout>
  )
}

export default Guides
